export default "__VITE_ASSET__nL8q1cJa__"